import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from "../../Assets/Images/logo.png"
import 'bootstrap/dist/css/bootstrap.css';
import { Modal, notification } from 'antd';
import config, { checkLoginStatus } from '../../pages/Config';
import secureLocalStorage from 'react-secure-storage';
import swal from 'sweetalert';
import { useAppContext } from './Appcontext';
import { FAQsteps } from './GuideSteps';
import Joyride, { EVENTS } from 'react-joyride'

const ContainerDashboard = ({ children, title, description }) => {
    const [profile_completed, setprofile_completed] = useState(true)
    const [mobileMenu, setMobileMenu] = useState(false)

    const location = useLocation()
    const navigate = useNavigate();

    const credential = secureLocalStorage.getItem("credentials")
    // console.log(credential)

    useEffect(() => {
        //     // check Login Status 
        if (!credential || credential.id === null) {
            navigate(`${config.appUrl}login`);
        }
        // location.pathname
    }, []);

    const onLogout = (e) => {
        e.preventDefault();

        swal({
            title: "Are you sure?",
            text: "You want to logout?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(willdelete => {
            if (willdelete) {
                secureLocalStorage.removeItem("credentials")
                secureLocalStorage.removeItem("FAQCompleted");

                notification.open({
                    message: (
                        <div className="d-flex">
                            <div className="pr-20">
                                <i
                                    className="icon-warning text-danger"
                                    style={{ fontSize: "20px" }}
                                ></i>
                            </div>
                            <div>Thank You !</div>
                        </div>
                    ),
                    description: "Your Account has been logout Successfully.",
                });
                navigate(`${config.appUrl}login`)
            }
        })

    }

    const menuItems = [
        {
            text: 'Dashboard',
            url: `${config.appUrl}`,
            icon: 'icon-home',
        },
        {
            text: 'Calendar',
            url: `${config.appUrl}calendar`,
            icon: 'icon-calendar-full',
            // disable: profile_completed
        },
        {
            text: 'Lessons',
            url: `${config.appUrl}lessons`,
            icon: 'icon-car2',
            // disable: profile_completed
        },
        {
            text: 'Claim History',
            url: `${config.appUrl}claim-history`,
            icon: 'icon-history',
        },
        {
            text: 'Students',
            url: `${config.appUrl}students`,
            icon: 'icon-users',
            // disable: profile_completed
        },
        {
            text: 'Your Courses',
            url: `${config.appUrl}courses`,
            icon: 'icon-book2',
            // disable: profile_completed
        },
        {
            text: 'Slots Availability',
            url: `${config.appUrl}availability`,
            icon: 'icon-question',
            // disable: profile_completed
        },
        {
            text: 'Support',
            url: `${config.appUrl}support`,
            icon: 'icon-hand',
        },
        {
            text: 'Profile',
            url: `${config.appUrl}profile`,
            icon: 'icon-user'
        },
        {
            text: 'Logout',
            // url: `${config.appUrl}profile`,
            icon: 'icon-exit-right',
        }

    ];

    const [Popup, setPopup] = useState(false)

    const { steps, setSteps, run, setRun, stepIndex, setStepIndex } = useAppContext();

    useEffect(() => {
        // Define your steps
        setSteps(FAQsteps);
    }, []);

    const handleCallback = (data) => {
        const { action, index, step, type } = data;
        const { next, previous, action: stepAction } = step?.data || {}; // Default to empty object if no data

        const isPreviousAction = action === 'prev';

        // Stop the tour when the user skips or closes it
        if (action === 'skip' || action === 'close') {
            setRun(false); // Stop the tour
            setStepIndex(0);
            navigate(`${config.appUrl}`);
        }

        if (type === EVENTS.STEP_AFTER) {
            // Handle when the tutorial reaches the last step
            if (index === steps.length - 1) {
                setStepIndex(0); // Reset step index to 0
            }

            if (stepAction === "end") {
                if (isPreviousAction && previous) {
                    setRun(true);
                    navigate(isPreviousAction && previous ? previous : next);
                    setStepIndex(index - 1);
                } else {
                    navigate(`${config.appUrl}`)
                    setRun(false)
                    setStepIndex(0);
                    swal({
                        title: "You are all Set!",
                        text: "Now you know how to use this system.",
                        icon: "success",
                        buttons: true,
                        dangerMode: true,
                    })
                }
            }

            // Handle navigating between steps
            if (stepAction === 'navigate' && next) {
                // Navigate to the next page
                navigate(next);
                setStepIndex(index + 1);
                setRun(true);
            }

            // Handle the action for other scenarios (e.g., button clicks, DOM interactions)
            if (stepAction === 'click') {
                const element = document.querySelector(step?.target);
                if (element) {
                    element.click(); // Trigger click on the target element
                }
                setStepIndex(index + 1);
                setRun(true);
            }

            // If there are any conditional actions (e.g., go back to the previous step)
            if (index < steps.length - 1) {
                navigate(isPreviousAction && previous ? previous : next);
                isPreviousAction ? setStepIndex(index - 1) : setStepIndex(index + 1);
            }
        }
    };

    useEffect(() => {
        if (credential?.has_seen_faq === 0 && secureLocalStorage.getItem("FAQCompleted")) {
            setTimeout(() => {
                secureLocalStorage.removeItem("FAQCompleted");
                setRun(true);
            }, 1000);
        }
    }, [credential])

    return (
        <div className="martfury-admin">
            <Joyride
                stepIndex={stepIndex}
                steps={steps}
                callback={handleCallback}
                run={run} // Trigger the tutorial based on this state
                continuous={true} // Keep moving to next step automatically
                scrollToFirstStep={false} // Scroll to the first step automatically
                showSkipButton={true} // Show a skip button
                showProgress={true} // Show progress of the tutorial
                hideCloseButton
                locale={{ last: "Ok" }}
                disableScrolling={true}
                styles={{
                    options: {
                        primaryColor: '#01922f',
                        zIndex: 10000, // Ensure the Joyride overlay is on top of other content

                    }
                }}
            />

            <main className="ps-main">
                <div className="ps-main__sidebar pt-0 overflow-auto" style={{ height: '100%', scrollbarWidth: 'none' }}>
                    <div className="ps-sidebar d-flex flex-column justify-content-between ">
                        <div >
                            <div className="ps-sidebar__top py-md-5 pb-md-4 position-sticky top-0 left-0 bg-black py-md-0 py-4" style={{ zIndex: "10" }}>
                                <div className='row align-items-center justify-content-between  ps-4 '>
                                    <div className='col-md-12 col-8 bg-gradientt p-4 ms-md-0 ms-4'
                                        style={{
                                            clipPath: "polygon(20% 0%, 86% 0, 100% 35%, 100% 80%, 100% 100%, 14% 100%, 0 65%, 0 0)"
                                        }}
                                    >   <Link to={`${config.appUrl}`}>
                                            <img src={logo} alt='' />
                                        </Link>
                                    </div>
                                    <div className='col-3 d-xl-none d-block text-end '>
                                        <div className='mb-4'>
                                            <i className='bi bi-box-arrow-right display-4 bg-danger px-2 rounded-4 border border-danger text-white'
                                                onClick={onLogout}
                                            ></i>
                                        </div>
                                        <div>
                                            <i className='bi bi-list display-4 bg-light px-2 rounded-4 border '
                                                onClick={() => setMobileMenu(!mobileMenu)}
                                            ></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`ps-sidebar__content overflow-scroll d-md-flex  d-block ${mobileMenu && 'show-menu'}`} style={{ scrollbarWidth: "none" }}>
                                <div className='d-xl-none d-block text-end mb-5'>
                                    <i className='bi bi-x display-4 bg-light px-2 rounded-4 border '
                                        onClick={() => setMobileMenu(!mobileMenu)}
                                    ></i>
                                </div>
                                <div className="ps-sidebar__center">
                                    <ul className="menu">
                                        {menuItems.map((item, index) => {
                                            return (
                                                <li
                                                    key={index}
                                                    className={`menustep${index + 1}`}
                                                >
                                                    {item.text == "Logout" ? (
                                                        <a onClick={onLogout}>
                                                            <i className={item.icon}></i>
                                                            {item.text}
                                                        </a>
                                                    ) : (
                                                        <>
                                                            <Link to={item.url}
                                                                onClick={(e) => {
                                                                    if (item.disable)
                                                                        e.preventDefault()
                                                                }}
                                                                className={location.pathname == item.url ? "active" : ""}>
                                                                <i className={item.icon}></i>
                                                                {item.text}
                                                            </Link>
                                                        </>
                                                    )}
                                                </li>
                                            )
                                        }
                                        )}
                                    </ul>
                                </div>
                                <div className="ps-4 pb-lg-5 footer-content">
                                    <div className="ps-copyright">
                                        <img src="/img/logo.png" alt="" />
                                        <p className='text-white mb-2'>
                                            &copy; {new Date().getFullYear()} Precision Driving.
                                        </p>
                                        <p className='text-white mb-0'> Designed & Developed By  <br />
                                            <a href='https://www.zithas.co.uk' target='_blank' className='text-green'> Zithas Technologies</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="ps-main__wrapper">
                    <header className="header--dashboard">
                        <div className="header__left">
                            <h3>{title}</h3>
                            <p>{description}</p>
                        </div>
                        <div className="header__center">
                            {/* <FormHeaderSearch /> */}
                        </div>
                        <div className="header__right">
                            <a onClick={() => {
                                setPopup(true)
                            }} className='bg-green text-white p-3 rounded-4'><i className="bi bi-info-circle-fill fs-4 me-2"></i><span className='fs-4'>Help Center</span></a>
                        </div>
                    </header>
                    {children}
                </div>
            </main>
            <Modal
                open={Popup}
                title={
                    <div className='d-flex justify-content-between align-items-center me-5'>
                        <h4 className='mb-0'>Help Section</h4>
                        <button className='py-2 px-4 btn text-white ms-2 rounded-4 bg-green fs-5' onClick={() => {
                            setPopup(false)
                            setRun(true)
                            setStepIndex(0)
                            navigate(`${config.appUrl}`)
                        }}>
                            Guide</button>
                    </div>
                }
                centered
                onCancel={() => setPopup(false)}
                width={800}
                bodyStyle={{ padding: '0' }}
                footer={null}
            >
                <div className="bg-gradientt p-4">
                    <div className='p-2 pb-0 Modal-New'>
                        <table className='table table-bordered' style={{ verticalAlign: 'middle' }}>
                            <tbody>
                                <tr>
                                    <th className='p-3 col-3'>Section</th>
                                    <th className='p-3'>Details</th>
                                </tr>
                                <tr>
                                    <td className='p-3 fs-4 fw-bold'>Dashboard</td>
                                    <td className='p-3 fw-semibold' style={{ color: "#333" }}>You can Find Overview of Lesson And Upcoming Lesson Slots Here.</td>
                                </tr>
                                <tr>
                                    <td className='p-3 fs-4 fw-bold'>Calender</td>
                                    <td className='p-3 fw-semibold' style={{ color: "#333" }}>You can Check your Lesson Slots in Month , Week and Day View for Better Understanding</td>
                                </tr>
                                <tr>
                                    <td className='p-3 fs-4 fw-bold'>Lessons</td>
                                    <td className='p-3 fw-semibold' style={{ color: "#333" }}>In this Section All Lessons Will Be shown you can give feedback of particular day slots in that.</td>
                                </tr>
                                <tr>
                                    <td className='p-3 fs-4 fw-bold'>Claim History</td>
                                    <td className='p-3 fw-semibold' style={{ color: "#333" }}>In this Section All Payments which admin have made to you will shown here and you can request for new payment from here.</td>
                                </tr>
                                <tr>
                                    <td className='p-3 fs-4 fw-bold'>Students</td>
                                    <td className='p-3 fw-semibold' style={{ color: "#333" }}>In this Section All your students will shown here</td>
                                </tr>
                                <tr>
                                    <td className='p-3 fs-4 fw-bold'>Your Cources</td>
                                    <td className='p-3 fw-semibold' style={{ color: "#333" }}>In This Section All cources in which you are included will shown here.</td>
                                </tr>
                                <tr>
                                    <td className='p-3 fs-4 fw-bold'>Slots Availability</td>
                                    <td className='p-3 fw-semibold' style={{ color: "#333" }}>In This Section you can manage your all slots for new lessons for all working days of week.</td>
                                </tr><tr>
                                    <td className='p-3 fs-4 fw-bold'>Support</td>
                                    <td className='p-3 fw-semibold' style={{ color: "#333" }}>If you have any Question so you can directly ask to admin using add Query and check reply of that.</td>
                                </tr>
                                <tr>
                                    <td className='p-3 fs-4 fw-bold'>Profile</td>
                                    <td className='p-3 fw-semibold' style={{ color: "#333" }}>In This Section you can manage your all details which is share with us.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ContainerDashboard;
